















































import {
  defineComponent,
  computed,
  useFetch,
  ref,
  ssrRef
} from '@nuxtjs/composition-api';
import { SfHeading, SfInput, SfAccordion } from '@storefront-ui/vue';
import { useFaq } from '@wemade-vsf/faq';
import type { FAQCategory } from '@wemade-vsf/faq';

export default defineComponent({
  name: 'FaqCategories',
  props: {
    title: {
      type: String,
      default: ''
    },
    showType: {
      type: String,
      default: 'all'
    },
    includeSearch: {
      type: Boolean,
      default: true
    },
    columns: {
      type: String,
      default: '1'
    },
    categoryIds: {
      type: String,
      default: ''
    }
  },
  components: {
    SfHeading,
    SfInput,
    SfAccordion
  },
  setup (props) {
    const { loading, loadFaqList } = useFaq()
    const rootCategories = ssrRef<FAQCategory[] | null>(null)
    const query = ref('');
    const categories = computed(() => {
      if (query.value.length >= 3 && rootCategories.value) {
        const q = query.value.toLowerCase()
        return rootCategories.value.map(c => {
          return {
            ...c,
            articles: {
              items: c.articles.items.filter(i => {
                return i.name.toLowerCase().indexOf(q) > -1 || i.article_content.toLowerCase().indexOf(q) > -1
              })
            }
          }
        })
      } else {
        return rootCategories.value
      }
    })

    useFetch(async () => {
      let baseQuery = {
        filter: {
          enabled: { eq: '1' }
        },
        pageSize: 100,
        currentPage: 1
      }
      if (props.showType === 'custom' && props.categoryIds) {
        baseQuery.filter['category_id'] = { in: props.categoryIds.split(',') }
      }
      rootCategories.value = await loadFaqList(baseQuery);  
    })


    return {
      loading,
      categories,
      query
    }
  }
})
